import { Helmet } from 'react-helmet-async';
import { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import profile from 'src/store/profile';
import api from 'src/utils/api';
// @mui
import {
  Grid, Container,
  Snackbar, Alert, Card, CardContent, CardHeader, Stack, Button
} from '@mui/material';
import { CreateMessage } from 'src/sections/@dashboard/student';
import { MessageNews } from 'src/sections/@dashboard/app';
// components
import Iconify from '../../components/iconify';

// ----------------------------------------------------------------------

export default function DayPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [alert, setAlert] = useState(false);
  const [messages, setMessages] = useState([]);
  const [student] = useState(profile.isTeacher ? location.state : profile.data);

  const getMessages = useCallback(() => {
    api.get(`message-api?sort=-id&filter[type]=0&filter[student_id]=${student.id}`)
      .then((result) => {
        setMessages(result);
      })
      .catch(() => {
        setMessages([]);
      });
  }, [student.id])

  useEffect(() => {
    getMessages()
  }, [getMessages])
  return (
    <>
      <Helmet>
        <title> Месенджер | Lala English </title>
      </Helmet>

      <Alert severity="error" sx={{ mb: 5, pl: 3 }}>Твоя переписка з вчителем.</Alert>
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 6 } }}>
        {profile.isTeacher ? (
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Button onClick={() => navigate(-1)} variant="outlined" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Назад
            </Button>
          </Stack>
        ) : null }
        <Grid container spacing={3} sx={{ 'flexDirection': 'row-reverse'}}>
          <Grid item xs={12} md={6} lg={4}>
            <Card>
              <CardHeader title="Нове повідомлення" />

              <CardContent>
                <CreateMessage type={0} student={student} success={() => {
                  getMessages();
                  setAlert(true)
                }} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={8}>
            <MessageNews
              title=""
              list={messages.map((message) => ({
                id: message.id,
                title: message.teacher_id === message.student_id ? 'Студент:' : 'Вчитель:',
                description: message.text,
                image: message.teacher_id === message.student_id ? '/assets/images/avatars/avatar_default.jpg' : '/assets/images/covers/cover_5.jpg',
                postedAt: message.date,
                link: message.link,
              }))}
            />
          </Grid>
          <Snackbar open={alert} autoHideDuration={4000} onClose={() => setAlert(false)}>
            <Alert severity="success" variant="filled" sx={{ width: '100%' }}>
              Успішно відправлено!
            </Alert>
          </Snackbar>
        </Grid>
      </Container>
    </>
  );
}
